// extracted by mini-css-extract-plugin
module.exports = {"icon":"Rule_icon__37BAu"};